module.exports = __webpack_public_path__ + "img/A03.d56e0a68.jpg";